import React from 'react';
import bindAll from 'lodash.bindall';
import { Box } from "@chakra-ui/layout";
import IconButton from '../components/icon-button/icon-button.jsx';
import '../monitorDrawer/SegmentedRadio.css';
import downloadIcon from './assets/icon--download.svg';
import downloadingIcon from './assets/icon--downloading.gif';
import PropTypes from 'prop-types';
import {compose} from 'redux';
import {
    injectIntl,
    FormattedMessage,
    defineMessages
} from 'react-intl';
import {connect} from 'react-redux';
// import VM from 'scratch-vm';
// import {showAlertWithTimeout} from '../reducers/alerts.js';
import classNames from 'classnames';
// import {closeLoadingModal, openLoadingModal, openConnectionModal} from '../reducers/modals';
import {Button, Modal, message} from 'antd';
import {ExclamationCircleFilled} from '@ant-design/icons';
import {getMobileOS} from '../lib/supported-browser.js';
import { setConnectModal } from '../store/modals'
// import {setConnectionModalExtensionId} from '../reducers/connection-modal.js';
// import {setConnectionMode, setLocalConnected} from '../reducers/connection-modal';

const {confirm} = Modal;

const messages = defineMessages({
    nowork: {
        id: 'project-action-nowork',
        defaultMessage: 'Workspace is empty.',
        description: 'Workspace is empty.'
    }
})

class DownloadBtn extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, ['handleDownload', 'handleCLick', 'showPromiseConfirm']);
        this.state = {
            downloading: false
        };
    }

    componentDidMount () {
        // document.addEventListener('keydown', this.handleKeyPress);
        // this.props.vm.on('SCRIPT_UPLOAD_FINISHED', res => {
        //     this.props.openLocalConnected();
        //     if (!res.name) {
        //         this.props.closeLoadingModal();
        //         this.setState({
        //             downloading: false
        //         });
        //         // if (res === 1) {
        //         //     this.showPromiseConfirm();
        //         // }
        //     }
        // });
    }

    showPromiseConfirm = () => {
        confirm({
            title: this.props.intl.formatMessage({
                defaultMessage: 'Resume Editing?',
                description: 'Resume Editing?',
                id: 'gui.mode.title'
            }),
            icon: <ExclamationCircleFilled />,
            centered: true,
            content: this.props.intl.formatMessage({
                defaultMessage: 'The device has entered offline mode. Click OK to restore online editing and operation.',
                description: 'The device has entered offline mode. Click OK to restore online editing and operation.',
                id: 'gui.mode.content'
            }),
            okText: this.props.intl.formatMessage({
                defaultMessage: 'OK',
                description: 'OK',
                id: 'gui.prompt.ok'
            }),
            cancelText: this.props.intl.formatMessage({
                defaultMessage: 'Cancel',
                description: 'Cancel',
                id: 'gui.prompt.cancel'
            }),
            onOk () {
                return new Promise((resolve, reject) => {
                    window.peripheral.checkVersion().then(r => resolve());
                }).catch(() => console.log('Oops errors!'));
            },
            onCancel () {}
        });
    };

    handleCLick () {}

    handleStop () {
        // this.props.vm.clickStopAll();
        // this.props.vm.stopAll();
    }

    handleDownload () {
        let str = ''
        let data = null
        // 根据项目名将内容发送给小车
        let projectName = localStorage.getItem("projectName") || localStorage.getItem("projectTitle")
        // console.log(this.props.fs['fs']['fs']['_files'], 88999)
        if (!projectName) {
            data = new Uint8Array(this.props.fs['fs']['fs']['_files']['main.py']['_dataBytes']);
        } else {
            data = new Uint8Array(this.props.fs['fs']['fs']['_files'][projectName]['_dataBytes']);
        }
        // console.log(projectName, 'projectName', data)
        // 将 Uint8Array 转换成字符串
        for (let i = 0; i < data.length; i++) {
            str += String.fromCharCode(data[i]);
        }
        const pythonCode = str
        str = str.replace(/\n\s*\n/g, '\n'); // 删除多余的空行
        str = str.replace(/\s+/g, ' '); // 将多个空格替换为单个空格
        if (str === ' ' || str === ' # Your new file!' || str === '# Your new file! ' || str === ' # Your new file! ') {
            message.error(this.props.intl.formatMessage(messages.nowork));
        } else {
            localStorage.setItem('pythonStr', JSON.stringify(pythonCode))
            // 没有连接小车直接下载到本地，有连接下载到小车
            if (!window.peripheral.isConnected()) {
                const blob = new Blob([data], {
                    type: "application/octet-stream",
                });
                const filename = `${projectName ? projectName  : 'main.py'}`;
                saveAs(blob, filename);
                // this.props.setConnectModal(true)
                // return;
                // window.peripheral.usb('0x303a')
            } else {
                window.peripheral.downloadCode(pythonCode)
                return false
            }
        }
        // const pythonCode = str
        // window.peripheral.downloadCode(pythonCode)
        // const blocks = document.querySelector('.blocklyWorkspace .blocklyBlockCanvas');
        // if (blocks.getBBox().height === 0) {
        //     this.props.onWorkspaceIsEmpty();
        // } else if (getMobileOS() !== 'PC' && !this.props.vm.getPeripheralIsConnected('Nous')) {
        //     this.props.onShowExtensionAlert('Nous');
        // } else {
        //     this.props.closeLocalConnected();
        //     this.handleStop();
        //     this.props.openLoadingModal();
        //     this.props.vm.downloadCode(this.props.codeEditorValue, this.props.projectTitle);
        //     this.setState(
        //         {
        //             downloading: true
        //         },
        //         () => {
        //             // 没有链接设备，动画100ms；
        //             if (!this.props.vm.getPeripheralIsConnected('Nous')) {
        //                 this.props.closeLoadingModal();
        //                 setTimeout(() => {
        //                     this.setState({
        //                         downloading: false
        //                     });
        //                 }, 100);
        //             }
        //         }
        //     );
        // }
    }

    render () {
        if (this.state.downloading) {
            return (
                <Box>
                    <IconButton
                        className="commonButton"
                        img={downloadingIcon}
                        iconClassName="downloadingIcon"
                        onClick={this.handleCLick}
                    />
                </Box>
            );
        }

        return (
            <Box>
                <IconButton
                    className="commonButton"
                    img={downloadIcon}
                    onClick={this.handleDownload}
                />
            </Box>
        );
    }
}

DownloadBtn.propTypes = {
    fs: PropTypes.object
    // codeEditorValue: PropTypes.string,
    // // vm: PropTypes.instanceOf(VM).isRequired,
    // onWorkspaceIsEmpty: PropTypes.func.isRequired,
    // openLoadingModal: PropTypes.func,
    // closeLoadingModal: PropTypes.func,
    // // intl: intlShape.isRequired,
    // onShowExtensionAlert: PropTypes.func
};

const mapStateToProps = state => ({
    // codeEditorValue: state.scratchGui.code.codeEditorValue,
    // projectTitle: state.scratchGui.projectTitle
});

const mapDispatchToProps = dispatch => ({
    setConnectModal: (state) => dispatch(setConnectModal(state))
    // onWorkspaceIsEmpty: () => showAlertWithTimeout(dispatch, 'workspaceIsEmpty'),
    // openLoadingModal: () => dispatch(openLoadingModal()),
    // closeLoadingModal: () => dispatch(closeLoadingModal()),
    // onShowExtensionAlert: data => {
    //     dispatch(setConnectionModalExtensionId(data));
    //     dispatch(setConnectionMode('ble'));
    //     dispatch(openConnectionModal());
    // },
    // closeLocalConnected: () => dispatch(setLocalConnected(false)),
    // openLocalConnected: () => dispatch(setLocalConnected(true))
});

export default compose(injectIntl, connect(mapStateToProps, mapDispatchToProps))(DownloadBtn);
